import React from 'react'
import { useForm } from 'react-hook-form'
import { TextInput } from 'components/FormUtilsV2/TextInput/text-input'
import { Preview, Section, Col } from 'component-catalog/previews/PreviewKit'

interface DemoValues {
  name: string
  price: number | ''
  sku: string
  description: string
  disabled: string
}

export function TextInputMock(): React.ReactElement {
  const { control } = useForm<DemoValues>({
    defaultValues: {
      name: '',
      price: '',
      sku: 'FB-001',
      description: '',
      disabled: 'Read-only value',
    },
  })

  return (
    <Preview>
      <Section label="Text — floating label">
        <Col>
          <div className="w-72">
            <TextInput control={control} name="name" label="Variant Name" />
          </div>
          <div className="w-72">
            <TextInput
              control={control}
              name="description"
              label="Description"
              optional
            />
          </div>
        </Col>
      </Section>
      <Section label="Number — with prefix">
        <div className="w-72">
          <TextInput
            control={control}
            name="price"
            label="Avg Price per case"
            type="number"
            prefix="$"
          />
        </div>
      </Section>
      <Section label="Pre-filled value">
        <div className="w-72">
          <TextInput control={control} name="sku" label="SKU" />
        </div>
      </Section>
      <Section label="Disabled">
        <div className="w-72">
          <TextInput
            control={control}
            name="disabled"
            label="Read-only field"
            disabled
          />
        </div>
      </Section>
    </Preview>
  )
}
